import { jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M18 9L12 15L6 9", stroke: "currentColor", strokeWidth: 2 }) });
export default SvgChevronDown;
